import { DatePipe } from '@angular/common';
import AppValues from 'src/app/common/app.values';
import { GridTableBody, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';

import { ConnectionRequest } from '../relation-request.interface';

import { Injectable } from '@angular/core';
import { ConnectionStatus } from 'src/app/swagger-api/model/connectionStatus';
import { CellActionTooltipValues, CellActionTypes } from '../../tables/components/cell-actions.type';
import {
  ConnectionListTable,
  UserConnectionSentTable,
  UserConnectionTable,
  UserConnectionsReceivedTable,
} from './connection-tables';
import { RelationRequestTables } from './table-creator.enum';
import { RelationRequestTableFactory } from './user-relation-requests-table';

const linkedRequestTooltipValues: CellActionTooltipValues = {
  [CellActionTypes.REMOVE]: 'TOOLTIP_UNLINK_CONNECTION',
  [CellActionTypes.SEND_MSG]: 'TOOLTIP_SEND_MESSAGE',
};

const sentLinkRequestTooltipValues: CellActionTooltipValues = {
  [CellActionTypes.REMOVE]: 'TOOLTIP_REMOVE_REQUEST',
};

const receivedLinkRequestTooltipValues: CellActionTooltipValues = {
  [CellActionTypes.CONFIRM]: 'TOOLTIP_ACCEPT_REQUEST',
  [CellActionTypes.REJECT]: 'TOOLTIP_DECLINE_REQUEST',
};

export const userConnectionRowData: (connection: ConnectionRequest) => GridTableBody = (
  connection: ConnectionRequest,
) => {
  return {
    entityId: connection.relatedUser.user_id,
    actorId: connection.relatedUser.user_id,
    user: connection.relatedUser,
    manage: { status: true, reason: ConnectionStatus.Verified },
    created:
      new DatePipe('en-US').transform(
        connection.acceptanceDate || connection.invitationDate,
        AppValues.DATE_FORMAT_SHORT,
      ) ?? '',
  };
};

export const userConnectionLinkedRowData: (connection: ConnectionRequest) => GridTableBody = (
  connection: ConnectionRequest,
) => {
  return { ...userConnectionRowData(connection), tooltipValues: linkedRequestTooltipValues };
};

export const userConnectionSentRowData: (connection: ConnectionRequest) => GridTableBody = (
  connection: ConnectionRequest,
) => {
  return {
    ...userConnectionRowData(connection),
    manage: { status: true, reason: ConnectionStatus.Pending },
    tooltipValues: sentLinkRequestTooltipValues,
  };
};

export const userConnectionReceivedRowData: (connection: ConnectionRequest) => GridTableBody = (
  connection: ConnectionRequest,
) => {
  return {
    ...userConnectionRowData(connection),
    manage: { status: null, reason: null },
    tooltipValues: receivedLinkRequestTooltipValues,
  };
};

@Injectable()
export class ConnectionTableFactory extends RelationRequestTableFactory<ConnectionRequest> {
  public buildTableConstructorData(type: RelationRequestTables, items: ConnectionRequest[]): UserTableConstructorInfo {
    switch (type) {
      case RelationRequestTables.CONNECTION_REQUESTS:
        return new UserConnectionTable().buildTableData(items);

      case RelationRequestTables.CONNECTIONS_SENT_REQUESTS:
        return new UserConnectionSentTable().buildTableData(items);

      case RelationRequestTables.CONNECTIONS_RECEIVED_INVITES:
        return new UserConnectionsReceivedTable().buildTableData(items);

      case RelationRequestTables.CONNECTION_LIST:
        return new ConnectionListTable().buildTableData(items);

      default:
        return { header: [], body: [], attribute: null };
    }
  }
}
